import algoliasearch from 'algoliasearch/lite';

export const searchClient = algoliasearch(
  '901L4CISD9',
  '3aa1b7c2143a7b86957020910a5b62f1',
);
